const getActiveVirtualCertificate = (device) => {
  const unit = device?.businessUnit;
  const certificates = (unit?.certificates || []).filter(
    (certificate) => certificate.businessUnitId == null || Number(certificate.businessUnitId) === Number(unit.id)
  );
  if (unit?.activeCertificateId) {
    return certificates.find((certificate) => Number(certificate.id) === Number(unit.activeCertificateId)) || null;
  }
  return certificates.reduce((latest, certificate) =>
    !latest || Number(certificate.id) > Number(latest.id) ? certificate : latest, null);
};

const getDeviceCertificate = (device) => device?.salesDataController
  ? { validFrom: device.cardCertificateValidFrom, validTo: device.cardCertificateValidTo }
  : getActiveVirtualCertificate(device);

const getCertificateHistory = (device) => {
  const active = getActiveVirtualCertificate(device);
  return [...(device?.businessUnit?.certificates || [])].sort((left, right) =>
    Number(right.id === active?.id) - Number(left.id === active?.id) || Number(right.id) - Number(left.id));
};

export { getActiveVirtualCertificate, getDeviceCertificate, getCertificateHistory };
